/* Product page: variant selection, gallery, quantity. */
(() => {
  const init = (root) => {
    if (!root || root._product) return;
    root._product = true;
    const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    const form = root.querySelector('[data-product-form]');
    const idInput = root.querySelector('[data-variant-id]');
    const priceWrap = root.querySelector('[data-price-wrap] .price');
    const addBtn = root.querySelector('[data-add]');
    const addLabel = root.querySelector('[data-add-label]');
    const stock = root.querySelector('[data-stock]');
    const money = window.themeFormatMoney || ((c) => (c / 100).toFixed(2) + ' €');
    const strings = (window.theme && window.theme.strings) || {};
    const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    /* Specs that differ by option value (custom.specs_variants); missing keys fall back to the product. */
    const showSpecs = (v) => {
      const byOption = data.specsByOption;
      if (!byOption) return;
      const key = v.options.find((o) => byOption[o]);
      const set = key ? byOption[key] : {};
      const def = data.specsDefault || {};
      const body = document.querySelector('[data-specs-body]');
      const rows = set.specs || def.specs || [];
      if (body) body.innerHTML = rows.map((r) => `<tr><th scope="row">${esc(r[0])}</th><td class="num">${esc(r[1])}</td></tr>`).join('');
      root.querySelectorAll('[data-keyspec]').forEach((el) => {
        const val = set[el.dataset.keyspec] || def[el.dataset.keyspec] || '';
        el.hidden = !val;
        el.querySelector('dd').textContent = val;
      });
    };

    /* Gallery */
    const showMedia = (id) => {
      if (!id) return;
      root.querySelectorAll('.plate').forEach((p) => p.classList.toggle('is-active', p.dataset.mediaId === String(id)));
      root.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
    };
    root.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumb)));

    /* Quantity */
    root.querySelectorAll('[data-qty] [data-step]').forEach((b) => b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value) + Number(b.dataset.step));
    }));

    /* Variants */
    const selected = () => Array.from(root.querySelectorAll('[data-option]:checked')).sort((a, b) => a.dataset.option - b.dataset.option).map((i) => i.value);
    const update = (fromUser) => {
      const opts = selected();
      // Single-variant products render no option inputs: the only variant is the selection.
      const v = data.variants.length === 1 ? data.variants[0] : data.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      opts.forEach((val, i) => { const el = root.querySelector(`[data-option-value="${i}"]`); if (el) el.textContent = val; });
      // Mark values that do not exist together with the other current choices.
      root.querySelectorAll('[data-option]').forEach((input) => {
        const i = Number(input.dataset.option);
        const test = opts.slice(); test[i] = input.value;
        const match = data.variants.find((x) => x.options.every((o, j) => o === test[j]));
        input.disabled = !match;
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addLabel.textContent = strings.unavailable || '—'; }
        return;
      }
      idInput.value = v.id;
      if (priceWrap) {
        const current = priceWrap.querySelector('.price__current');
        if (current) current.textContent = money(v.price);
        const compare = priceWrap.querySelector('.price__compare');
        if (compare) compare.hidden = !(v.compare > v.price);
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? strings.addToCart : strings.soldOut;
      }
      if (stock) {
        const state = v.inStock ? 'in' : v.available ? 'order' : 'out';
        stock.classList.toggle('stock--out', state !== 'in');
        stock.textContent = stock.dataset[state];
      }
      showSpecs(v);
      showMedia(v.media);
      if (fromUser) {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.pathname + url.search);
      }
    };
    root.querySelectorAll('[data-option]').forEach((i) => i.addEventListener('change', () => update(true)));
    if (form && root.querySelector('[data-option]')) update(false);
  };
  document.querySelectorAll('[data-product]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-product]')));
})();
